<template>
  <div ref="eyeRef" class="eyeball" :style="{
    width: size + 'px', height: isBlinking ? '2px' : size + 'px',
    backgroundColor: eyeColor,
  }">
    <div v-if="!isBlinking" class="pupil-inner" :style="{
      width: pupilSize + 'px', height: pupilSize + 'px',
      backgroundColor: pupilColor,
      transform: `translate(${pos.x}px, ${pos.y}px)`,
    }" />
  </div>
</template>

<script>
export default {
  name: 'EyeBall',
  props: {
    size: { type: Number, default: 48 },
    pupilSize: { type: Number, default: 16 },
    maxDistance: { type: Number, default: 10 },
    eyeColor: { type: String, default: 'white' },
    pupilColor: { type: String, default: 'black' },
    isBlinking: { type: Boolean, default: false },
    forceLookX: { type: Number, default: undefined },
    forceLookY: { type: Number, default: undefined },
  },
  data() {
    return {
      mx: 0,
      my: 0,
    }
  },
  computed: {
    pos() {
      const eyeRef = this.$refs.eyeRef
      if (!eyeRef) return { x: 0, y: 0 }
      if (this.forceLookX !== undefined && this.forceLookY !== undefined) {
        return { x: this.forceLookX, y: this.forceLookY }
      }
      const r = eyeRef.getBoundingClientRect()
      const dx = this.mx - (r.left + r.width / 2)
      const dy = this.my - (r.top + r.height / 2)
      const d = Math.min(Math.sqrt(dx ** 2 + dy ** 2), this.maxDistance)
      const a = Math.atan2(dy, dx)
      return { x: Math.cos(a) * d, y: Math.sin(a) * d }
    },
  },
  methods: {
    onMove(e) {
      this.mx = e.clientX
      this.my = e.clientY
    },
  },
  mounted() {
    window.addEventListener('mousemove', this.onMove)
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMove)
  },
}
</script>

<style scoped>
.eyeball {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  overflow: hidden;
}
.pupil-inner {
  border-radius: 50%;
  transition: transform 0.1s ease-out;
}
</style>
